<template lang="pug">
AppDialog.project-dialog.delete-project(
  :key="show"
  append-to-body
  :show="show"
  title="Delete project"
  @close="closeDeleteDialog"
)
  .dialog-p
    AppAvatarInitial(
      size="small"
      :text="projectName"
    )
    span
      | {{ projectName }}

  .dialog-p
    | By deleting this project, you will lose the following information:
    ul.aligned-list
      li
        | {{ message }}
      li The to-dos inside the project and time tracked to them

  .dialog-p
    | Keep in mind that reports will no longer show this project, but you will still see payment records for approved
    | time tracked on this project.

  .dialog-p.warning
    i.hi-important
    strong This can't be undone

  .dialog-p(v-if="isActiveProject")
    | You can&nbsp;
    a.clickable.strong(
      href="#"
      tabindex="0"
      @click="archiveProject(project.id)"
    )
      | archive this project
    |
    | instead without losing any data.

  template(#footer)
    .flex-footer
      AppCheckbox.form-group(v-model="understood") I understand and wish to delete this project
      button.btn.btn-default(@click="closeDeleteDialog") Cancel
      button.btn.btn-danger(
        :disabled="disabled"
        @click="onDeleteProject(project.id)"
      ) Delete
</template>
<script>
import { mapActions } from 'vuex';
import { ProjectsResource } from '~/resources';
import { ACTIVE_PROJECT_STATUS } from '../../app_constants';

export default {
  name: 'ProjectDeleteDialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
    manualTimeApprovalFlagEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    disabled: true,
  }),
  computed: {
    understood: {
      get() {
        return !this.disabled;
      },
      set() {
        this.disabled = !this.disabled;
      },
    },
    projectName() {
      return this.project.name || ' ';
    },
    isActiveProject() {
      return this.project.status === ACTIVE_PROJECT_STATUS;
    },
    message() {
      if (this.manualTimeApprovalFlagEnabled) {
        return 'The project and all time tracked to it (including any manual time requests)';
      }

      return 'The project and all time tracked to it';
    },
  },
  methods: {
    ...mapActions(['deleteProject']),
    closeDeleteDialog() {
      this.disabled = true;
      this.$emit('close-delete-dialog');
    },
    archiveProject(id) {
      AjaxDialog.run(ProjectsResource.archiveDialogLink({ id }));
    },
    error() {
      this.$appMessage('Something went wrong. Please try again.');
    },
    success(response) {
      if (response.message) {
        this.closeDeleteDialog();
        this.$appMessage(response.message);
      } else {
        this.$appMessage('Something went wrong. Please try again.');
      }
    },
    onDeleteProject(id) {
      this.deleteProject(id).then(this.success, this.error);
    },
  },
};
</script>
